import { DeviceType, type BrowserType } from '../../../../../helpers/device.helper';

export const bankIdRedirectHash = 'bankid-redirect';

export function getBankIdLaunchUrl(autoStartToken: string, browser: BrowserType, currentUrl: string): string {
  const token = encodeURIComponent(autoStartToken);

  if (browser.deviceType === DeviceType.Android && browser.name !== 'chrome') return `bankid:///?autostarttoken=${token}&redirect=null`;

  if (browser.deviceType === DeviceType.Desktop) return `bankid:///?autostarttoken=${token}&redirect=null`;

  let redirectUrl = 'null';
  if (browser.deviceType === DeviceType.iOS) {
    if (browser.name === 'crios') redirectUrl = 'googlechromes://';
    else if (browser.name === 'fxios') redirectUrl = 'firefox://';
    else {
      const returnUrl = new URL(currentUrl);
      returnUrl.hash = bankIdRedirectHash;
      redirectUrl = returnUrl.toString();
    }
  }

  return `https://app.bankid.com/?autostarttoken=${token}&redirect=${encodeURIComponent(redirectUrl)}`;
}
